export const getUri = (uri: string, params: any = {}): string => {
    let tmpUri = uri

    Object.keys(params).forEach((param) => {
        tmpUri = tmpUri.replace(`:${param}`, params[param])
    })

    return tmpUri
}
